module.exports = __webpack_public_path__ + "img/user.a3d607f7.svg";